export default __webpack_public_path__ + "static/media/Path Of The Wind (Totoro OST) - Joe Hisaishi(Piano ver.).2a64899a.mp3";